<template>
    <custom-modal
        width="1200px"
        title="处理结果录入"
        :visible="visible"
        @on-close="handleClose"
    >
        <modal-content :utilization-info="utilizationInfo" @on-ok="handleOk" />

        <template #customFooter>
            <a-button @click.stop="handleClose">取消</a-button>
            <custom-portal-target :name="portalTarget" :slim="true" />
        </template>
    </custom-modal>
</template>
<script>
import { Button as AButton } from 'ant-design-vue'
import CustomModal from '@components/CustomModal'
import CustomPortalTarget from '@components/CustomPortalVue/PortalTarget'

import ModalContent, { PORTAL_KEY } from './Content'

export default {
    name: 'ResultEntryModal',
    components: {
        AButton,
        CustomModal,
        ModalContent,
        CustomPortalTarget
    },
    props: {
        visible: Boolean,
        utilizationInfo: Object
    },
    data() {
        return {
            portalTarget: PORTAL_KEY
        }
    },
    methods: {
        handleClose() {
            this.$emit('on-close')
        },
        handleOk() {
            this.handleClose()
            this.$emit('on-refresh')
        }
    }
}
</script>
